module.exports = __webpack_public_path__ + "static/img/activity_sdy_05-4.0f741fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_05-4.jpg
// module id = R6Np
// module chunks = 0